/**
 * EmailJS account the site's forms send through. Where the notification lands,
 * the subject line and any auto-reply to the customer are set on the EmailJS
 * dashboard for this template, not here.
 */
export const EMAILJS = {
  serviceId: "service_xedvn6r",
  templateId: "template_ib5kavn",
  publicKey: "lefNpA0eeHK4rVGKZ",
};
